import { NgModule } from '@angular/core';
import { MarkdownPipe } from './markdown.pipe';


@NgModule({
    imports: [],
    exports: [MarkdownPipe],
    declarations: [MarkdownPipe],
    providers: [],
})
export class MarkdownPipeModule { }
